/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { getLang, getLanguage } from '@/server/lib/language';
import { GetServerSideProps } from 'next';
import device from '@/client/utils/device';
import { nodeProxy } from '@/server/lib/methods/common';

import style from './index.module.scss';
import Progress from '@/client/components/dandelion/progress';
import WeeklyHead from '@/client/components/dandelion/weeklyHead';
import StaticLayout from '@/static/layout/staticLayout';

import { parseQuery } from '@/client/utils/url';
import { openOrDownload } from '@/client/utils/methods/common';
import { ONELINK_URL } from '@/client/assets/lang/inviteFriends/home';
import toast from '@/client/utils/methods/toast';
import { getSsrShareConf } from '@/client/incentive/lib/utils';

import useWeblog from '@/static/hook/useWeblog';

export const Lang = [
  'weekly_title',
  'week_share_desc',
  'invite_104194', // 邀请语
  'invite_105238', // 奖励提示
  'invite_105237', // 邀请按钮
  'invite_58890', // 活动结束
  'invite_105218', // 页面标题
  'please_update_app', // 请升级app
  'toast_update_app', // toast提示升级app
] as const;
export type LangType = { [key in typeof Lang[number]]: string };

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req, query = {} } = context;
  const { headers: header } = req;
  const { uniqueStr, source='whatsapp' } = query;
  const lang = getLang((Lang as any) as string[], header);
  try {
    const resData = await nodeProxy(`laxin::/rest/bulldog/w/activity/assistance/shareHome?uniqueStr=${uniqueStr}`, {
      header,
      method: 'get',
    });
    const langCode = getLanguage(header);
    const currencyToBucket = {
      Rp: 'in',
      Rs: 'pak',
      Taka: 'bgd',
    };
    const shareOpenGraph = await getSsrShareConf({
      source: source as string,
      page: 'weekly',
      langCode,
      bucket: currencyToBucket[resData?.data?.currencyUnit] || '',
    });
    return { props: { lang, query, data: resData, shareOpenGraph } };
  } catch (error) {
    return { props: { lang, query, data: {}, shareOpenGraph: {} } };
  }
};

const Share = ({ lang, data, query, shareOpenGraph }: any) => {
  const shareInfo = data?.data || {
    newUserBindCodeAmount: 0,
    totalAssistanceAmount: 0,
    hasAssistanceAmount: 0,
    shareUserHead: '',
    assistanceAwardThresholdList: [],
    shareUserName: 'SnackVideo',
    currencyUnit: '',
    activityStartTime: 0,
    activityEndTime: 0,
  };
  const [timeover, setTimeover] = useState(false);

  function formatInviteText() {
    return lang.invite_104194
      ?.replace(/\$?\{0\}/, shareInfo?.shareUserName || 'SnackVideo')
      .replace('${1}', `${shareInfo?.currencyUnit}${Number(shareInfo?.totalAssistanceAmount).toLocaleString()}`);
  }

  function formatShareText() {
    return lang.week_share_desc
      ?.replace('${0}', shareInfo?.shareUserName || 'SnackVideo')
      .replace('${1}', `${shareInfo?.currencyUnit} ${Number(shareInfo?.totalAssistanceAmount).toLocaleString()}`)
      .replace('${2}', '');
  }

  useEffect(() => {
    if (data?.result === 1016069045) {
      setTimeover(true);
      toast.show(lang.invite_58890, 3000);
    }
  }, [data, lang]);

  const weblog = useWeblog(
    {
      fps: false,
      timing: false,
      radar: {
        projectId: '47ca42d004',
        sampling: 0.9,
      },
    },
    {},
    (weblog) => {
      const page = 'GET_EXTRA_EVERY_WEEK_OUTH5';
      weblog.sendPv({
        type: 'enter',
        page,
      });
      weblog.logger.plugins.radar?.fmp();

      const beginTime = Date.now();
      window.addEventListener('beforeunload', () => {
        weblog.sendPv({
          type: 'leave',
          page,
          params: {},
          beginTime,
        });
      });
    },
  );
  const openApp = () => {
    const { uniqueStr = '', source = '' } = parseQuery();
    const { origin } = window.location;
    toast.show(lang.toast_update_app, 3000);
    weblog?.sendClick({
      action: 'HELP',
    });
    const buckets = {
      Rp: 'in',
      Rs: 'pak',
      Taka: 'bgd',
    };
    const path = `/one/events/dandelion/weekly?source=${source}&uniqueStr=${uniqueStr}&bucket=${buckets[shareInfo.currencyUnit] || ''}&hyId=snack_pages`;
    if (device.isInSnack()) {
      window?.location?.replace?.(timeover ? `ikwaibulldog://home?source=${source}` : path);
      return;
    }
    const kwaiUrl = timeover
      ? `ikwaibulldog://home?source=${source}`
      : `ikwaibulldog://webview?url=${encodeURIComponent(`${origin}${path}`)}`;
    openOrDownload(kwaiUrl, `${ONELINK_URL}&af_sub1=${encodeURIComponent(JSON.stringify({ uniqueStr, source }))}`);
  };
  return (
    <StaticLayout
      title={lang.invite_105218}
      loadingConfig={{ background: '#ffdc10' }}
      share={{
        shareTitle: lang.weekly_title.replace('${0}', `${shareInfo?.currencyUnit || ''} ${(+shareInfo?.totalAssistanceAmount)?.toLocaleString() || 0}`),
        description: formatShareText(),
        shareImg: shareOpenGraph?.shareImg,
        siteUrl: `https://m.snackvideo.com/one/events/dandelion/weeklyshare?source=${query?.source}&uniqueStr=${query?.uniqueStr}`,
      }}
    >
      <div onClick={() => openApp()}>
        <div className={style.fixedUpdateText}>{lang.please_update_app}</div>
        <WeeklyHead
          lang={lang}
          total={shareInfo?.totalAssistanceAmount || 0}
          currency={shareInfo?.currencyUnit}
          start={shareInfo?.activityStartTime || 0}
          end={shareInfo?.activityEndTime || 0}
          hasRule={false}
          hasNotice={true}
        ></WeeklyHead>
        <div className={style.invitePanel}>
          <div className={style.avatar}>
            <div style={{ backgroundImage: `url(${shareInfo?.shareUserHead})` }} className={style.img}></div>
          </div>
          {timeover ? (
            <div className={style.timeOverMsg}>{lang.invite_58890}</div>
          ) : (
            <div className={style.panelContent}>
              <div className={style.inviteMsg}>{formatInviteText()}</div>
              <div
                className={style.progressWrapper}
                style={{
                  display: shareInfo?.assistanceAwardThresholdList?.length ? 'block' : 'none',
                }}
              >
                <Progress
                  marks={shareInfo?.assistanceAwardThresholdList || []}
                  value={shareInfo?.hasAssistanceAmount}
                  currency={shareInfo?.currencyUnit}
                ></Progress>
              </div>
              <div className={style.inviteBtn}>{lang.invite_105237}</div>
              <div className={style.extraUpTitle}>{lang.invite_105238}</div>
              <div className={style.extraUpCount}>
                {shareInfo?.currencyUnit} {(+shareInfo?.newUserBindCodeAmount)?.toLocaleString() || 0}
              </div>
            </div>
          )}
        </div>
      </div>
    </StaticLayout>
  );
};

export default Share;

// interface ShareInfo {
//   newUserBindCodeAmount: number;
//   totalAssistanceAmount: number;
//   hasAssistanceAmount: number;
//   shareUserHead: string;
//   assistanceAwardThresholdList: number[];
//   shareUserName: string;
//   currencyUnit: '' | 'Rp' | 'Rs';
//   activityStartTime: number;
//   activityEndTime: number;
// }
